const isSubstringFound = (haystack: string, needle: string): boolean => {
	if (!needle) return true;
	if (!haystack) return false;
	const haystackLowerCase = haystack.toLocaleLowerCase();
	const needleLowerCase = needle.toLocaleLowerCase();
	return haystackLowerCase.includes(needleLowerCase);
};

export default isSubstringFound;
